import {
  FETCH_COUNTRIES,
  FETCH_COUNTRIES_SUCCESS,
  FETCH_COUNTRIES_FAILS,
} from './countryActionTypes';
import { getActiveCountries } from '../../api/countryApi';
import { FALLBACK_COUNTRIES, mergeCountryRegistry, normaliseCountry } from '../../utils/country';

/**
 * Loads the market registry. A failure is not fatal: the app keeps the bundled fallback list
 * so country resolution and the switcher still work.
 */
export const fetchCountries = () => async (dispatch) => {
  dispatch({ type: FETCH_COUNTRIES });

  try {
    const countries = await getActiveCountries();
    if (!Array.isArray(countries) || countries.length === 0) {
      throw new Error('empty country registry');
    }

    dispatch({
      type: FETCH_COUNTRIES_SUCCESS,
      payload: mergeCountryRegistry(countries.map(normaliseCountry)),
    });
  } catch (error) {
    dispatch({
      type: FETCH_COUNTRIES_FAILS,
      payload: { error, countries: FALLBACK_COUNTRIES },
    });
  }
};
